unit DonationDataEdit;

interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  Vcl.Controls,
  Vcl.StdCtrls,
  WEBLib.StdCtrls,
  Data.DB,
  WEBLib.DB,
  WEBLib.DBCtrls,
  WEBLib.WebCtrls,
  WebForm.Core, WEBLib.ExtCtrls,
  XData.Web.Dataset, XData.Web.JsonDataset,
  Essentials.Web.Attributes.Form,
  GA.Return.Types,
  XData.Web.Client;

type
  TDonationValidation = class
    AmountValid: Boolean;
    TransactionDateValid: Boolean;
    PaymentMethodValid: Boolean;
    DonationKindValid: Boolean;
    DonationClaimStatusValid: Boolean;
    function PassesValidation: Boolean;
    procedure ValidateAmount(aAmount: string; aIsUnclaimed: Boolean; out aErrorText: string);
    procedure ValidatePaymentMethod(aComboItemIndex: Integer; out aErrorText: string);
    procedure ValidateDonationDate(aIsUnclaimed: Boolean; aDonationDate, aDateOfDeath: TDate; out aErrorText: string);
    procedure ValidateDonationKind(aComboItemIndex: Integer; aValue: string; aIsUnclaimed: Boolean; out aErrorText: string);
    procedure ValidateDonationClaimStatus(aComboItemIndex: integer; out aErrorText: string);
    constructor Create;
  end;

  TDonationDataEditForm = class(TCoreWebForm)
    AmountDonation: TDBEdit;
    DonorPostCode: TDBEdit;
    SaveButton: TButton;
    CancelButton: TButton;
    ClaimStatus: TDBEdit;
    EditDataSource: TDataSource;
    DonationDateEdit: TDBDateTimePicker;
    ErrorMessageDonationDate: TLabel;
    ErrorMessageAmount: TLabel;
    ErrorMessageDonationKind: TLabel;
    ErrorMessagePaymentMethod: TLabel;
    ErrorMessageDonationClaimStatus: TLabel;
    SponsoredEditDB: TDBCheckBox;
    BankingDateEdit: TDBDateTimePicker;
    OtherDonationKindEdit: TDBEdit;
    PaymentMethodNoteEdit: TDBEdit;
    DonationKindCombo: TDBLookupComboBox;
    PaymentMethodCombo: TDBLookupComboBox;
    CommentMemo: TDBMemo;
    AnalysisCode1Combo: TDBComboBox;
    AnalysisCode2Combo: TDBComboBox;
    BankingReference2Edit: TDBEdit;
    BankingReferenceCombo: TDBComboBox;
    DonationClaimStatus: TDBLookupComboBox;
    DataState: THTMLSpan;
    DonationRefresh: TTimer;
    procedure AmountDonationChange(Sender: TObject);
    procedure AmountDonationKeyPress(Sender: TObject; var Key: Char);
    procedure CancelButtonClick(Sender: TObject);
    procedure CloseButtonClick(Sender: TObject);
    procedure DonationDateEditChange(Sender: TObject);
    procedure EditDataSourceDataChange(Sender: TObject; Field: TField);
    procedure SaveButtonClick(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure DonationKindComboChange(Sender: TObject);
    procedure OtherDonationKindEditExit(Sender: TObject);
    procedure PaymentMethodNoteEditExit(Sender: TObject);
    procedure PaymentMethodComboChange(Sender: TObject);
    procedure DonationClaimStatusChange(Sender: TObject);
    procedure BankingDateEditExit(Sender: TObject);
    procedure DonationDateEditExit(Sender: TObject);
    procedure DonationRefreshTimer(Sender: TObject);
  private
    { Private declarations }
    FValidation: TDonationValidation;
    FEditDataApplyUpdates: boolean;
    FAttributesForm: TEssentialsAttributesForm;
    FDonorId: integer;
    FDonorClaimStatus: string;
    FDateOfDeath: TDate;
    FSingleDeclarationId: integer;
    FDonationId: integer;
    FAllowEdit: Boolean;
    FLockedViewMode: Boolean;
    procedure SetDataSet(Value: TDataSet);
    [async]
    procedure LoadEssentials; async;
    procedure CheckValidations;
    procedure DetermineOtherDonationKindVisibility;
    procedure DeterminePaymentMethodNoteVisibility;
    procedure DetermineConditionalUIVisibility;
    function IsUnclaimed: Boolean;
    procedure InitAttributesForm;
    procedure SetAllowEdit(AAllowEdit: Boolean);
    procedure ViewModeOn;
    procedure EditModeOn;
    procedure EnterLockedViewMode;
    procedure EnterEditMode;
    function CanUseEditToggle: Boolean;
    procedure SetPrimaryActionButton(const ACaption: string);
    procedure SetEditingControlsEnabled(const AEnabled: Boolean);
    procedure UpdatePrimaryActionEnabled;
    function IsReadOnlyMode: Boolean;
    procedure UpdateDataState;
    [async]
    function CheckUnclaimedDonation(out AReason: string): Boolean; async;
    [async]
    procedure TrySave; async;
    //procedure CheckDeclaration;
    public
    { Public declarations }
    constructor Create(aOwner: TComponent); override;
    destructor Destroy; override;
    procedure CheckEdit;
    property DataSet: TDataSet write SetDataSet;
    property EditDataApplyUpdates: boolean read FEditDataApplyUpdates;
    property AllowEdit: Boolean write SetAllowEdit;

    property DonorId: integer read FDonorId write FDonorId;
    property DonorClaimStatus: string read FDonorClaimStatus write FDonorClaimStatus;
    property DateOfDeath: TDate read FDateOfDeath write FDateOfDeath;
    property SingleDeclarationId: integer read FSingleDeclarationId write FSingleDeclarationId;
    property DonationId: integer read FDonationId;
  protected procedure LoadDFMValues; override; end;

var
  DonationDataEditForm: TDonationDataEditForm;

implementation

{$R *.dfm}

uses
  DonationList, SMX.Web.Document.Utils, GA.Web.Utils,
  Essentials.Web.Shared, MainDataModule,
  System.Rtti, System.TypInfo, Essentials.Web.Manager, Essentials.RequiredFields.UtilityUnit,
  System.Math, GA.Rules;

procedure TDonationDataEditForm.AmountDonationChange(Sender: TObject);
begin
  CheckEdit;
end;

procedure TDonationDataEditForm.AmountDonationKeyPress(Sender: TObject; var
    Key: Char);
begin
  if (Pos('.', AmountDonation.Text) > 0) and (Key = '.') then
  begin
    Key := #0;
    exit;
  end;

  if (not (Key in ['0'..'9','.']) or (Length(TEdit(Sender).Text) > 7)) then
  begin
    TDocUtils.setControlValidity('AmountDonation', vsInvalid);
    Key := #0;
  end
  else
  begin
    TDocUtils.setControlValidity('AmountDonation', vsValid);
  end;
end;

procedure TDonationDataEditForm.CancelButtonClick(Sender: TObject);
begin
  inherited;
  if CanUseEditToggle and (not IsReadOnlyMode) and (not FLockedViewMode) then
  begin
    if Assigned(EditDataSource.DataSet) and (EditDataSource.DataSet.State in dsEditModes) then
      EditDataSource.DataSet.Cancel;
    EnterLockedViewMode;
    Exit;
  end;

  if Assigned(EditDataSource.DataSet) and (EditDataSource.DataSet.State in dsEditModes) then
    EditDataSource.DataSet.Cancel;

  ModalResult := mrOk;
end;

procedure TDonationDataEditForm.CloseButtonClick(Sender: TObject);
begin
  inherited;
  if Assigned(EditDataSource.DataSet) and (EditDataSource.DataSet.State in dsEditModes) then
    EditDataSource.DataSet.Cancel;
  ModalResult := mrOk;
end;

constructor TDonationDataEditForm.Create(aOwner: TComponent);
begin
  inherited;
  FValidation := TDonationValidation.Create;
  FAllowEdit := True;
  FLockedViewMode := False;
end;

procedure TDonationDataEditForm.EditDataSourceDataChange(Sender: TObject; Field: TField);
begin
  // Keep conditional controls in sync with bound field values,
  // especially on initial dataset bind in viewing mode.
  DetermineConditionalUIVisibility;

  if IsReadOnlyMode or FLockedViewMode then
    CancelButton.Caption := 'Close'
  else
    CancelButton.Caption := 'Cancel';

  UpdateDataState;
end;

procedure TDonationDataEditForm.InitAttributesForm;
  procedure AfterAttributeFormCreated(AForm: TObject);
  begin
    FAttributesForm := TEssentialsAttributesForm(AForm);
    FAttributesForm.Name := 'DonationAttributesForm';
    FAttributesForm.EntityClassName := 'TDonation';
    FAttributesForm.EntityId := EditDataSource.DataSet.FieldByName('Id').AsInteger;
  end;
begin
  if Assigned(FAttributesForm) then
  begin
    FAttributesForm.EntityClassName := 'TDonation';
    FAttributesForm.EntityId := EditDataSource.DataSet.FieldByName('Id').AsInteger;
  end
  else
    Application.CreateForm(TEssentialsAttributesForm, 'essentials.attributes.container', FAttributesForm,
      @AfterAttributeFormCreated);
end;

procedure TDonationDataEditForm.LoadEssentials;
begin
  Await(EssentialsManager.FormSetUp(Self));
  TRequiredFieldsUtils.UpdateRequiredFieldsValidity(Self);
end;

procedure TDonationDataEditForm.OtherDonationKindEditExit(Sender: TObject);
begin
  if OtherDonationKindEdit.Enabled = False then
    EditDataSource.DataSet.FieldByName('OtherDonationKind').AsString := '';
end;

procedure TDonationDataEditForm.PaymentMethodComboChange(Sender: TObject);
begin
  DeterminePaymentMethodNoteVisibility;
  CheckEdit;

  if PaymentMethodCombo.Value <> TDOnationUIUtils.OTHER then
    EditDataSource.DataSet.FieldByName('PaymentMethodNote').AsString := '';
end;

procedure TDonationDataEditForm.PaymentMethodNoteEditExit(Sender: TObject);
begin
  if PaymentMethodNoteEdit.Enabled = False then
    EditDataSource.DataSet.FieldByName('PaymentMethodNote').AsString := '';
end;

procedure TDonationDataEditForm.SaveButtonClick(Sender: TObject);
begin
  if FLockedViewMode and CanUseEditToggle then
  begin
    EnterEditMode;
    Exit;
  end;

  TrySave;
end;

procedure TDonationDataEditForm.TrySave;
var
  LReason: string;
  LCheckOk: Boolean;
  LModalResult: TModalResult;
  lAmountValue: Currency;
begin
  // Clear empty combo selections before validation
  EssentialsManager.LookUpManager.ClearEmptyComboSelections(Self);

  if not TRequiredFieldsUtils.ValidateAndShowMessage(Self) then
    Exit;

  if IsUnclaimed then
  begin
    LCheckOk := await(Boolean, CheckUnclaimedDonation(LReason));
    if not LCheckOk then
    begin
      LModalResult := await(TModalResult,
        MessageDlgAsync(
          'This donation cannot be saved as Unclaimed.' + '<br>' + '<br>' +
          LReason + '<br>' + '<br>' +
          'Do you want to save it as Non-GiftAidable instead?' + '<br>' +
          '(Yes = Save as Non-GiftAidable, No = Go back)',
          mtWarning, [mbYes, mbNo]));

      if LModalResult = mrNo then
        Exit;

      EditDataSource.DataSet.FieldByName('ClaimStatus').AsString := 'NonGiftAidable';
    end;
  end;

  if EditDataSource.DataSet.FieldByName('ClaimStatus').AsString = 'Unclaimed' then
  begin
    lAmountValue := EditDataSource.DataSet.FieldByName('Amount').AsFloat;
    EditDataSource.DataSet.FieldByName('GiftAid').AsFloat := RoundTo(lAmountValue * 0.25, -2);
  end
  else
  begin
    EditDataSource.DataSet.FieldByName('GiftAid').AsFloat := 0.00;
  end;

  EditDataSource.DataSet.Post;
  if EditDataSource.DataSet is TXDataWebDataSet then
    TXDataWebDataSet(EditDataSource.DataSet).ApplyUpdates;
  fEditDataApplyUpdates := true;
  SaveButton.Enabled := False;
  FDonationId := EditDataSource.DataSet.FieldByName('Id').AsInteger;
  DonationRefresh.Enabled := True;

  if CanUseEditToggle then
    EnterLockedViewMode;

end;

procedure TDonationDataEditForm.SetDataSet(Value: TDataSet);
var
  s: string;
begin
  EditDataSource.DataSet := Value;
  if (Value <> nil) and Value.Active and (Value.FindField('ClaimStatus') <> nil) then
  begin
    s := Trim(Value.FieldByName('ClaimStatus').AsString);
    if SameText(s, 'Invalid') or SameText(s, 'Failed') then
    begin
      if Value.State in dsEditModes then
        Value.FieldByName('ClaimStatus').AsString := 'Unclaimed';
      DonationClaimStatus.Value := 'Unclaimed';
    end;
  end;
  LoadEssentials;
  InitAttributesForm;
  DetermineConditionalUIVisibility;

  if CanUseEditToggle then
    EnterLockedViewMode
  else if IsReadOnlyMode then
    ViewModeOn
  else
  begin
    EditModeOn;
    CheckEdit;
    UpdateDataState;
  end;
end;

destructor TDonationDataEditForm.Destroy;
begin
  FreeAndNil(FAttributesForm);
  FValidation.Free;
  inherited;
end;

procedure TDonationDataEditForm.DetermineConditionalUIVisibility;
begin
  DetermineOtherDonationKindVisibility;
  DeterminePaymentMethodNoteVisibility;
end;

procedure TDonationDataEditForm.DetermineOtherDonationKindVisibility;
var
  LDonationKindValue: string;
begin
  LDonationKindValue := Trim(DonationKindCombo.Value);
  if (LDonationKindValue = '') and Assigned(EditDataSource.DataSet) and
    Assigned(EditDataSource.DataSet.FindField('DonationKind')) then
    LDonationKindValue := Trim(EditDataSource.DataSet.FieldByName('DonationKind').AsString);

  OtherDonationKindEdit.Visible := SameText(LDonationKindValue, TDonationUIUtils.OTHER);
  TDocUtils.ShowHideLabel('OtherDonationKindEdit', OtherDonationKindEdit.Visible);
  TDocUtils.ShowHideLabel('donation.otherdonationkind.row', OtherDonationKindEdit.Visible);
  TDocUtils.ShowHideLabel('donation.otherdonationkind.label', OtherDonationKindEdit.Visible);
end;

procedure TDonationDataEditForm.DeterminePaymentMethodNoteVisibility;
var
  LPaymentMethodValue: string;
begin
  LPaymentMethodValue := Trim(PaymentMethodCombo.Value);
  if (LPaymentMethodValue = '') and Assigned(EditDataSource.DataSet) and
    Assigned(EditDataSource.DataSet.FindField('PaymentMethod')) then
    LPaymentMethodValue := Trim(EditDataSource.DataSet.FieldByName('PaymentMethod').AsString);

  PaymentMethodNoteEdit.Visible := SameText(LPaymentMethodValue, TDonationUIUtils.OTHER);
  TDocUtils.ShowHideLabel('PaymentMethodNoteEdit', PaymentMethodNoteEdit.Visible);
  TDocUtils.ShowHideLabel('donation.paymentmethodnote.row', PaymentMethodNoteEdit.Visible);
  TDocUtils.ShowHideLabel('donation.paymentmethodnote.label', PaymentMethodNoteEdit.Visible);
end;

function TDonationDataEditForm.IsUnclaimed: Boolean;
var
  s: string;
begin
  s := Trim(DonationClaimStatus.Value);
  if s = '' then
    s := Trim(EditDataSource.DataSet.FieldByName('ClaimStatus').AsString);
  Result := SameText(s, 'Unclaimed');
end;

procedure TDonationDataEditForm.DonationClaimStatusChange(Sender: TObject);
begin
  CheckEdit;
end;

procedure TDonationDataEditForm.DonationDateEditChange(Sender: TObject);
begin
  CheckEdit;
end;

procedure TDonationDataEditForm.DonationKindComboChange(Sender: TObject);
begin
  DetermineOtherDonationKindVisibility;
  CheckEdit;
  if DonationKindCombo.Value <> TDonationUIUtils.OTHER then
    EditDataSource.DataSet.FieldByName('OtherDonationKind').AsString := '';
end;

procedure TDonationDataEditForm.WebFormShow(Sender: TObject);
begin
  inherited;
  TDonationUIUtils.AddPaymentMethodLookupsToCombo(PaymentMethodCombo.LookupValues);
  TDonationUIUtils.AddDonationKindLookupsToCombo(DonationKindCombo.LookupValues);
  TDonationUIUtils.AddDonationClaimStatusLookupsToCombo(DonationClaimStatus.LookupValues);
  DetermineConditionalUIVisibility;

  if CanUseEditToggle then
    EnterLockedViewMode
  else
    UpdateDataState;
end;

procedure TDonationDataEditForm.DonationRefreshTimer(Sender: TObject);
begin
  inherited;
  EditDataSource.DataSet.Locate('Id', FDonationId, []);
  DonationRefresh.Enabled := False;
end;

procedure TDonationDataEditForm.CheckEdit;
var
  errorTextAmount: string;
  errorTextDate: string;
  errorTextPaymentMethod: string;
  errorTextDonationKind: string;
  errorTextClaimStatus: string;
begin
  UpdatePrimaryActionEnabled;
  if IsReadOnlyMode or FLockedViewMode then
    Exit;

  FValidation.ValidateAmount(AmountDonation.Text, IsUnclaimed, errorTextAmount);
  ErrorMessageAmount.Caption := errorTextAmount;
  FValidation.ValidateDonationDate(IsUnclaimed, DonationDateEdit.Date, FDateOfDeath, errorTextDate);
  ErrorMessageDonationDate.Caption := errorTextDate;
  FValidation.ValidatePaymentMethod(PaymentMethodCombo.ItemIndex, errorTextPaymentMethod);
  ErrorMessagePaymentMethod.Caption := errorTextPaymentMethod;
  FValidation.ValidateDonationKind(DonationKindCombo.ItemIndex, DonationKindCombo.Value, IsUnclaimed, errorTextDonationKind);
  ErrorMessageDonationKind.Caption := errorTextDonationKind;
  FValidation.ValidateDonationClaimStatus(DonationClaimStatus.ItemIndex, errorTextClaimStatus);
  ErrorMessageDonationClaimStatus.Caption := errorTextClaimStatus;
  CheckValidations;
end;

procedure TDonationDataEditForm.SetAllowEdit(AAllowEdit: Boolean);
begin
  FAllowEdit := AAllowEdit;
  if not FAllowEdit then
    FLockedViewMode := True;

  if Assigned(EditDataSource.DataSet) then
  begin
    if IsReadOnlyMode then
      ViewModeOn
    else if EditDataSource.DataSet.State = dsInsert then
    begin
      EditModeOn;
      UpdateDataState;
    end
    else
      EnterLockedViewMode;
  end;
end;

function TDonationDataEditForm.IsReadOnlyMode: Boolean;
begin
  Result := not FAllowEdit;
end;

procedure TDonationDataEditForm.UpdateDataState;
begin
  if not Assigned(EditDataSource.DataSet) then
    Exit;

  case EditDataSource.DataSet.State of
    dsEdit:
      DataState.HTML.Text := 'Editing';
    dsInsert:
      DataState.HTML.Text := 'Adding';
  else
    if not FAllowEdit then
      DataState.HTML.Text := 'Viewing (Read Only)'
    else
      DataState.HTML.Text := 'Viewing';
  end;
end;

procedure TDonationDataEditForm.EditModeOn;
begin
  FLockedViewMode := False;
  EditDataSource.AutoEdit := True;
  SetEditingControlsEnabled(True);
  SaveButton.Visible := True;
  SetPrimaryActionButton('Save');
  UpdatePrimaryActionEnabled;
  CancelButton.Caption := 'Cancel';
end;

procedure TDonationDataEditForm.ViewModeOn;
begin
  FLockedViewMode := True;
  EditDataSource.AutoEdit := False;
  SetEditingControlsEnabled(False);
  SaveButton.Visible := CanUseEditToggle;
  UpdatePrimaryActionEnabled;
  if CanUseEditToggle then
    SetPrimaryActionButton('Edit');
  CancelButton.Caption := 'Close';
  UpdateDataState;
end;

procedure TDonationDataEditForm.EnterLockedViewMode;
begin
  ViewModeOn;
  DetermineConditionalUIVisibility;
end;

procedure TDonationDataEditForm.EnterEditMode;
begin
  EditModeOn;
  DetermineConditionalUIVisibility;
  if not (EditDataSource.DataSet.State in dsEditModes) then
    EditDataSource.DataSet.Edit;
  CheckEdit;
  UpdateDataState;
end;

function TDonationDataEditForm.CanUseEditToggle: Boolean;
begin
  Result := FAllowEdit and Assigned(EditDataSource.DataSet) and
    (EditDataSource.DataSet.State <> dsInsert);
end;

procedure TDonationDataEditForm.SetPrimaryActionButton(const ACaption: string);
begin
  // Icon is supplied by global CSS based on SaveButton aria-label.
  SaveButton.Caption := ACaption;
  if Assigned(SaveButton.ElementHandle) then
    SaveButton.ElementHandle.setAttribute('aria-label', ACaption);
end;

procedure TDonationDataEditForm.SetEditingControlsEnabled(const AEnabled: Boolean);
begin
  AmountDonation.Enabled := AEnabled;
  DonorPostCode.Enabled := AEnabled;
  ClaimStatus.Enabled := AEnabled;
  DonationDateEdit.Enabled := AEnabled;
  ErrorMessageDonationDate.Enabled := AEnabled;
  ErrorMessageAmount.Enabled := AEnabled;
  ErrorMessageDonationKind.Enabled := AEnabled;
  ErrorMessagePaymentMethod.Enabled := AEnabled;
  ErrorMessageDonationClaimStatus.Enabled := AEnabled;
  SponsoredEditDB.Enabled := AEnabled;
  BankingDateEdit.Enabled := AEnabled;
  OtherDonationKindEdit.Enabled := AEnabled;
  PaymentMethodNoteEdit.Enabled := AEnabled;
  DonationKindCombo.Enabled := AEnabled;
  PaymentMethodCombo.Enabled := AEnabled;
  CommentMemo.Enabled := AEnabled;
  AnalysisCode1Combo.Enabled := AEnabled;
  AnalysisCode2Combo.Enabled := AEnabled;
  BankingReference2Edit.Enabled := AEnabled;
  BankingReferenceCombo.Enabled := AEnabled;
  DonationClaimStatus.Enabled := AEnabled;
end;

procedure TDonationDataEditForm.UpdatePrimaryActionEnabled;
begin
  if IsReadOnlyMode then
    SaveButton.Enabled := False
  else if FLockedViewMode then
    SaveButton.Enabled := CanUseEditToggle
  else
    SaveButton.Enabled := FValidation.PassesValidation;
end;


function TDonationDataEditForm.CheckUnclaimedDonation(out AReason: string): Boolean;
var
  lRetval: TXDataClientResponse;
  lResult: JS.TJSObject;
  lDeclarationData: TDeclarationData;
  lTransactionDate: TDate;
  lDonorId: integer;
  lDonationClaimStatus: string;
  lDonationId: integer;
begin
  AReason := '';
  if not FValidation.PassesValidation then
  begin
    AReason := 'This donation fails one or more validation checks.';
    Exit(False);
  end;

  lDonationClaimStatus := EditDataSource.DataSet.FieldByName('ClaimStatus').AsString;

  //We are only bothered about the declaration if the DonationClaimStatus = 'Unclaimed'
  if lDonationClaimStatus = 'Unclaimed' then
  begin
    lDonationId := EditDataSource.DataSet.FieldByName('Id').AsInteger;
    lDonorId := EditDataSource.DataSet.FieldByName('DonorId').AsInteger;
    lTransactionDate := DonationDateEdit.Date;

    lRetval := await(TXDataClientResponse,
      MainData.WebClient.RawInvokeAsync('IGiftAiderService.CheckDeclaration',
        [lDonorId, lDonationId, lTransactionDate]));

    lResult := lRetval.ResultAsObject;
    lDeclarationData := TDeclarationData.Create;
    try
      lDeclarationData.Assign(lResult);

      if lDeclarationData.Coverage = 'Single' then
        FSingleDeclarationId := lDeclarationData.Id;

      if (FDonorClaimStatus = 'Deceased') and (DonationDateEdit.Date > FDateOfDeath) then
      begin
        AReason := 'The donation date is after the donor''s date of death.';
        Exit(False);
      end;                                    {handled above}
      if (FDonorClaimStatus <> 'OK') and (FDonorClaimStatus <> 'Deceased') then
      begin
        AReason := 'The donor''s status is not OK for Gift Aid (current status: ' + FDonorClaimStatus + ').';
        Exit(False);
      end;
      if lDeclarationData.StatusOk = False then
      begin
        AReason := 'There is no valid Gift Aid declaration covering this donation.';
        Exit(False);
      end;
    finally
      lDeclarationData.Free;
    end;
  end;

  Result := True;
end;

procedure TDonationDataEditForm.CheckValidations;
begin
  UpdatePrimaryActionEnabled;
end;

{ TDonationValidation }

constructor TDonationValidation.Create;
begin
  AmountValid := False;
  TransactionDateValid := False;
  DonationKindValid := False;
  PaymentMethodValid := False;
  DonationClaimStatusValid := False;
end;

function TDonationValidation.PassesValidation: Boolean;
begin
  Result := AmountValid and DonationKindValid and TransactionDateValid and PaymentMethodValid and DonationClaimStatusValid;
end;

procedure TDonationValidation.ValidateAmount(aAmount: string; aIsUnclaimed: Boolean; out aErrorText: string);
var
  AdjValue: currency;
begin
  aErrorText := '';
  if aAmount <> '' then
  begin
    AdjValue := strtofloat(aAmount);
    if (AdjValue > 0) or (not aIsUnclaimed) then
    begin
      TDocUtils.setControlValidity('AmountDonation', vsValid);
      AmountValid := True;
    end
    else
    begin
      aErrorText := 'Amount must be greater than zero for Gift Aid.';
      TDocUtils.setControlValidity('AmountDonation', vsInValid);
      AmountValid := False;
    end;
  end
  else
  begin
    aErrorText := 'Amount is required.';
    TDocUtils.setControlValidity('AmountDonation', vsInvalid);
    AmountValid := False;
  end;
end;

procedure TDonationValidation.ValidateDonationDate(aIsunclaimed: Boolean; aDonationDate, aDateOfDeath: TDate; out aErrorText: string);
var
  EarliestDate: TDateTime;
begin
  aErrorText := '';
  TransactionDateValid := True;

  if aDonationDate = 0 then
  begin
    aErrorText := 'Donation Date cannot be blank.';
    TDocUtils.setControlValidity('DonationDateEdit', vsInvalid);
    TransactionDateValid := False;
  end
  else if aDonationDate > Date then
  begin
    aErrorText := 'Donation Date cannot be in the future.';
    TDocUtils.setControlValidity('DonationDateEdit', vsInvalid);
    TransactionDateValid := False;
  end
  else if (aDateOfDeath > 0) and (aDonationDate > aDateOfDeath) then
  begin
    aErrorText := 'Donation Date cannot be after date of death.';
    TDocUtils.setControlValidity('DonationDateEdit', vsInvalid);
    TransactionDateValid := False;
  end
  else
  begin
    if not aIsUnclaimed then
      TransactionDateValid := True
    else
    begin
      EarliestDate := TGAWebUtils.EarliestClaimableDate(Now);

      if EarliestDate > aDonationDate then
      begin
        aErrorText := 'Donation Date cannot be before ' + FormatDateTime('DD/MM/YYYY', EarliestDate) + '.';
        TDocUtils.setControlValidity('DonationDateEdit', vsInvalid);
        TransactionDateValid := False;
      end;
    end;
  end;

  if TransactionDateValid then
    TDocUtils.setControlValidity('DonationDateEdit', vsValid);
end;

procedure TDonationValidation.ValidateDonationKind(aComboItemIndex: Integer; aValue: string; aIsUnclaimed: Boolean; out aErrorText: string);
begin
  aErrorText := '';
  DonationKindValid := aComboItemIndex <> -1;
  if aIsUnclaimed then
    DonationKindValid := aValue = 'Donation';

  if DonationKindValid then
    TDocUtils.setControlValidity('DonationKindCombo', vsValid)
  else
  begin
    if (aComboItemIndex = -1) then
      aErrorText := 'Donation kind must be selected.'
    else
      aErrorText := 'Only kind "Donation" is eligible for Gift Aid.';
    TDocUtils.setControlValidity('DonationKindCombo', vsInvalid);
  end;
end;

procedure TDonationValidation.ValidateDonationClaimStatus(aComboItemIndex: integer; out aErrorText: string);
begin
  aErrorText := '';
  DonationClaimStatusValid := aComboItemIndex <> -1;
  if DonationClaimStatusValid then
    TDocUtils.setControlValidity('DonationClaimStatus', vsValid)
  else
  begin
    aErrorText := 'Donation claim status must be selected.';
    TDocUtils.setControlValidity('DonationClaimStatus', vsInvalid);
  end;
end;

procedure TDonationValidation.ValidatePaymentMethod(aComboItemIndex: Integer; out aErrorText: string);
begin
  aErrorText := '';
  PaymentMethodValid := aComboItemIndex <> -1;
  if PaymentMethodValid then
    TDocUtils.setControlValidity('PaymentMethodCombo', vsValid)
  else
  begin
    aErrorText := 'Payment method must be selected.';
    TDocUtils.setControlValidity('PaymentMethodCombo', vsInvalid);
  end;
end;

procedure TDonationDataEditForm.DonationDateEditExit(Sender: TObject);
begin
  DonationDateEdit.Date := TGARulesUtils.MinDateCheck(DonationDateEdit.Date);
  CheckEdit;
end;

procedure TDonationDataEditForm.BankingDateEditExit(Sender: TObject);
begin
  BankingDateEdit.Date := TGARulesUtils.MinDateCheck(BankingDateEdit.Date);
  CheckEdit;
end;


procedure TDonationDataEditForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  ErrorMessageDonationDate := TLabel.Create('ErrorMessageDonationDate');
  ErrorMessageAmount := TLabel.Create('ErrorMessageAmount');
  ErrorMessageDonationKind := TLabel.Create('ErrorMessageDonationKind');
  ErrorMessagePaymentMethod := TLabel.Create('ErrorMessagePaymentMethod');
  ErrorMessageDonationClaimStatus := TLabel.Create('ErrorMessageDonationClaimStatus');
  DataState := THTMLSpan.Create('DataState');
  AmountDonation := TDBEdit.Create('AmountDonation');
  DonorPostCode := TDBEdit.Create('DonorPostCode');
  SaveButton := TButton.Create('SaveButton');
  CancelButton := TButton.Create('CancelButton');
  ClaimStatus := TDBEdit.Create('ClaimStatus');
  DonationDateEdit := TDBDateTimePicker.Create('DonationDateEdit');
  SponsoredEditDB := TDBCheckBox.Create('SponsoredEditDB');
  BankingDateEdit := TDBDateTimePicker.Create('BankingDate');
  OtherDonationKindEdit := TDBEdit.Create('OtherDonationKindEdit');
  PaymentMethodNoteEdit := TDBEdit.Create('PaymentMethodNoteEdit');
  BankingReferenceCombo := TDBComboBox.Create('BankingReferenceCombo');
  DonationKindCombo := TDBLookupComboBox.Create('DonationKindCombo');
  PaymentMethodCombo := TDBLookupComboBox.Create('PaymentMethodCombo');
  CommentMemo := TDBMemo.Create('CommentMemo');
  AnalysisCode1Combo := TDBComboBox.Create('AnalysisCode1Combo');
  AnalysisCode2Combo := TDBComboBox.Create('AnalysisCode2Combo');
  BankingReference2Edit := TDBEdit.Create('BankingReference2Edit');
  DonationClaimStatus := TDBLookupComboBox.Create('DonationClaimStatus');
  EditDataSource := TDataSource.Create(Self);
  DonationRefresh := TTimer.Create(Self);

  ErrorMessageDonationDate.BeforeLoadDFMValues;
  ErrorMessageAmount.BeforeLoadDFMValues;
  ErrorMessageDonationKind.BeforeLoadDFMValues;
  ErrorMessagePaymentMethod.BeforeLoadDFMValues;
  ErrorMessageDonationClaimStatus.BeforeLoadDFMValues;
  DataState.BeforeLoadDFMValues;
  AmountDonation.BeforeLoadDFMValues;
  DonorPostCode.BeforeLoadDFMValues;
  SaveButton.BeforeLoadDFMValues;
  CancelButton.BeforeLoadDFMValues;
  ClaimStatus.BeforeLoadDFMValues;
  DonationDateEdit.BeforeLoadDFMValues;
  SponsoredEditDB.BeforeLoadDFMValues;
  BankingDateEdit.BeforeLoadDFMValues;
  OtherDonationKindEdit.BeforeLoadDFMValues;
  PaymentMethodNoteEdit.BeforeLoadDFMValues;
  BankingReferenceCombo.BeforeLoadDFMValues;
  DonationKindCombo.BeforeLoadDFMValues;
  PaymentMethodCombo.BeforeLoadDFMValues;
  CommentMemo.BeforeLoadDFMValues;
  AnalysisCode1Combo.BeforeLoadDFMValues;
  AnalysisCode2Combo.BeforeLoadDFMValues;
  BankingReference2Edit.BeforeLoadDFMValues;
  DonationClaimStatus.BeforeLoadDFMValues;
  EditDataSource.BeforeLoadDFMValues;
  DonationRefresh.BeforeLoadDFMValues;
  try
    Width := 567;
    Height := 682;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    ErrorMessageDonationDate.SetParentComponent(Self);
    ErrorMessageDonationDate.Name := 'ErrorMessageDonationDate';
    ErrorMessageDonationDate.Left := 344;
    ErrorMessageDonationDate.Top := 8;
    ErrorMessageDonationDate.Width := 219;
    ErrorMessageDonationDate.Height := 25;
    ErrorMessageDonationDate.Caption := 'ErrorMessageDonationDate';
    ErrorMessageDonationDate.HeightPercent := 100.000000000000000000;
    ErrorMessageDonationDate.WidthPercent := 100.000000000000000000;
    ErrorMessageAmount.SetParentComponent(Self);
    ErrorMessageAmount.Name := 'ErrorMessageAmount';
    ErrorMessageAmount.Left := 168;
    ErrorMessageAmount.Top := 8;
    ErrorMessageAmount.Width := 5;
    ErrorMessageAmount.Height := 25;
    ErrorMessageAmount.HeightPercent := 100.000000000000000000;
    ErrorMessageAmount.WidthPercent := 100.000000000000000000;
    ErrorMessageDonationKind.SetParentComponent(Self);
    ErrorMessageDonationKind.Name := 'ErrorMessageDonationKind';
    ErrorMessageDonationKind.Left := 191;
    ErrorMessageDonationKind.Top := 120;
    ErrorMessageDonationKind.Width := 5;
    ErrorMessageDonationKind.Height := 25;
    ErrorMessageDonationKind.HeightPercent := 100.000000000000000000;
    ErrorMessageDonationKind.WidthPercent := 100.000000000000000000;
    ErrorMessagePaymentMethod.SetParentComponent(Self);
    ErrorMessagePaymentMethod.Name := 'ErrorMessagePaymentMethod';
    ErrorMessagePaymentMethod.Left := 191;
    ErrorMessagePaymentMethod.Top := 197;
    ErrorMessagePaymentMethod.Width := 5;
    ErrorMessagePaymentMethod.Height := 25;
    ErrorMessagePaymentMethod.HeightPercent := 100.000000000000000000;
    ErrorMessagePaymentMethod.WidthPercent := 100.000000000000000000;
    ErrorMessageDonationClaimStatus.SetParentComponent(Self);
    ErrorMessageDonationClaimStatus.Name := 'ErrorMessageDonationClaimStatus';
    ErrorMessageDonationClaimStatus.Left := 342;
    ErrorMessageDonationClaimStatus.Top := 197;
    ErrorMessageDonationClaimStatus.Width := 5;
    ErrorMessageDonationClaimStatus.Height := 25;
    ErrorMessageDonationClaimStatus.HeightPercent := 100.000000000000000000;
    ErrorMessageDonationClaimStatus.WidthPercent := 100.000000000000000000;
    DataState.SetParentComponent(Self);
    DataState.Name := 'DataState';
    DataState.Left := 408;
    DataState.Top := 622;
    DataState.Width := 136;
    DataState.Height := 25;
    DataState.HeightStyle := ssAuto;
    DataState.WidthStyle := ssAuto;
    DataState.ChildOrder := 6;
    DataState.ElementPosition := epIgnore;
    DataState.ElementFont := efCSS;
    DataState.Role := '';
    AmountDonation.SetParentComponent(Self);
    AmountDonation.Name := 'AmountDonation';
    AmountDonation.Left := 40;
    AmountDonation.Top := 8;
    AmountDonation.Width := 121;
    AmountDonation.Height := 22;
    AmountDonation.AutoCompletion := acNone;
    AmountDonation.AutoSelect := False;
    AmountDonation.ChildOrder := 1;
    AmountDonation.ElementClassName := 'form-control';
    AmountDonation.ElementFont := efCSS;
    AmountDonation.ElementPosition := epIgnore;
    AmountDonation.HeightStyle := ssAuto;
    AmountDonation.HeightPercent := 100.000000000000000000;
    AmountDonation.Text := 'AmountDonation';
    AmountDonation.WidthStyle := ssAuto;
    AmountDonation.WidthPercent := 100.000000000000000000;
    SetEvent(AmountDonation, Self, 'OnChange', 'AmountDonationChange');
    SetEvent(AmountDonation, Self, 'OnExit', 'AmountDonationChange');
    SetEvent(AmountDonation, Self, 'OnKeyPress', 'AmountDonationKeyPress');
    AmountDonation.DataField := 'Amount';
    AmountDonation.DataSource := EditDataSource;
    DonorPostCode.SetParentComponent(Self);
    DonorPostCode.Name := 'DonorPostCode';
    DonorPostCode.Left := 40;
    DonorPostCode.Top := 64;
    DonorPostCode.Width := 121;
    DonorPostCode.Height := 22;
    DonorPostCode.AutoCompletion := acNone;
    DonorPostCode.AutoSelect := False;
    DonorPostCode.ChildOrder := 3;
    DonorPostCode.ElementClassName := 'form-control';
    DonorPostCode.ElementFont := efCSS;
    DonorPostCode.ElementPosition := epIgnore;
    DonorPostCode.HeightStyle := ssAuto;
    DonorPostCode.HeightPercent := 100.000000000000000000;
    DonorPostCode.TabOrder := 2;
    DonorPostCode.Text := 'DonorPostCode';
    DonorPostCode.Visible := False;
    DonorPostCode.WidthStyle := ssAuto;
    DonorPostCode.WidthPercent := 100.000000000000000000;
    SaveButton.SetParentComponent(Self);
    SaveButton.Name := 'SaveButton';
    SaveButton.Left := 40;
    SaveButton.Top := 622;
    SaveButton.Width := 96;
    SaveButton.Height := 25;
    SaveButton.Caption := 'Save';
    SaveButton.ChildOrder := 4;
    SaveButton.ElementClassName := 'btn btn-light';
    SaveButton.ElementFont := efCSS;
    SaveButton.ElementPosition := epIgnore;
    SaveButton.Enabled := False;
    SaveButton.HeightStyle := ssAuto;
    SaveButton.HeightPercent := 100.000000000000000000;
    SaveButton.WidthStyle := ssAuto;
    SaveButton.WidthPercent := 100.000000000000000000;
    SetEvent(SaveButton, Self, 'OnClick', 'SaveButtonClick');
    CancelButton.SetParentComponent(Self);
    CancelButton.Name := 'CancelButton';
    CancelButton.Left := 152;
    CancelButton.Top := 622;
    CancelButton.Width := 96;
    CancelButton.Height := 25;
    CancelButton.Caption := 'Cancel';
    CancelButton.ChildOrder := 5;
    CancelButton.ElementClassName := 'btn btn-light';
    CancelButton.ElementFont := efCSS;
    CancelButton.ElementPosition := epIgnore;
    CancelButton.HeightStyle := ssAuto;
    CancelButton.HeightPercent := 100.000000000000000000;
    CancelButton.WidthStyle := ssAuto;
    CancelButton.WidthPercent := 100.000000000000000000;
    SetEvent(CancelButton, Self, 'OnClick', 'CancelButtonClick');
    ClaimStatus.SetParentComponent(Self);
    ClaimStatus.Name := 'ClaimStatus';
    ClaimStatus.Left := 40;
    ClaimStatus.Top := 92;
    ClaimStatus.Width := 300;
    ClaimStatus.Height := 22;
    ClaimStatus.AutoCompletion := acNone;
    ClaimStatus.AutoSelect := False;
    ClaimStatus.ChildOrder := 4;
    ClaimStatus.ElementClassName := 'form-control';
    ClaimStatus.ElementFont := efCSS;
    ClaimStatus.ElementPosition := epIgnore;
    ClaimStatus.HeightStyle := ssAuto;
    ClaimStatus.HeightPercent := 100.000000000000000000;
    ClaimStatus.TabOrder := 3;
    ClaimStatus.Text := 'ClaimStatus';
    ClaimStatus.Visible := False;
    ClaimStatus.WidthStyle := ssAuto;
    ClaimStatus.WidthPercent := 100.000000000000000000;
    ClaimStatus.DataField := 'ClaimStatus';
    ClaimStatus.DataSource := EditDataSource;
    DonationDateEdit.SetParentComponent(Self);
    DonationDateEdit.Name := 'DonationDateEdit';
    DonationDateEdit.Left := 40;
    DonationDateEdit.Top := 36;
    DonationDateEdit.Width := 121;
    DonationDateEdit.Height := 22;
    DonationDateEdit.ElementClassName := 'form-control';
    DonationDateEdit.HeightStyle := ssAuto;
    DonationDateEdit.WidthStyle := ssAuto;
    DonationDateEdit.BorderStyle := bsSingle;
    DonationDateEdit.ChildOrder := 8;
    DonationDateEdit.Color := clWhite;
    DonationDateEdit.Date := 45191.330952881940000000;
    DonationDateEdit.ElementFont := efCSS;
    DonationDateEdit.ElementPosition := epIgnore;
    DonationDateEdit.Role := '';
    DonationDateEdit.Text := 'DonationDateEdit';
    SetEvent(DonationDateEdit, Self, 'OnChange', 'DonationDateEditChange');
    SetEvent(DonationDateEdit, Self, 'OnExit', 'DonationDateEditExit');
    DonationDateEdit.DataField := 'TransactionDate';
    DonationDateEdit.DataSource := EditDataSource;
    SponsoredEditDB.SetParentComponent(Self);
    SponsoredEditDB.Name := 'SponsoredEditDB';
    SponsoredEditDB.Left := 40;
    SponsoredEditDB.Top := 364;
    SponsoredEditDB.Width := 113;
    SponsoredEditDB.Height := 22;
    SponsoredEditDB.Caption := 'Sponsored';
    SponsoredEditDB.ChildOrder := 15;
    SponsoredEditDB.ElementClassName := 'custom-control custom-checkbox';
    SponsoredEditDB.ElementButtonClassName := 'custom-control-input';
    SponsoredEditDB.ElementLabelClassName := 'custom-control-label';
    SponsoredEditDB.ElementFont := efCSS;
    SponsoredEditDB.ElementPosition := epIgnore;
    SponsoredEditDB.HeightStyle := ssAuto;
    SponsoredEditDB.HeightPercent := 100.000000000000000000;
    SponsoredEditDB.TabOrder := 14;
    SponsoredEditDB.WidthStyle := ssAuto;
    SponsoredEditDB.WidthPercent := 100.000000000000000000;
    SponsoredEditDB.DataField := 'Sponsored';
    SponsoredEditDB.DataSource := EditDataSource;
    BankingDateEdit.SetParentComponent(Self);
    BankingDateEdit.Name := 'BankingDateEdit';
    BankingDateEdit.Left := 40;
    BankingDateEdit.Top := 336;
    BankingDateEdit.Width := 170;
    BankingDateEdit.Height := 22;
    BankingDateEdit.ElementClassName := 'form-control';
    BankingDateEdit.BorderStyle := bsSingle;
    BankingDateEdit.ChildOrder := 17;
    BankingDateEdit.Color := clWhite;
    BankingDateEdit.Date := 45978.612005416670000000;
    BankingDateEdit.Role := '';
    BankingDateEdit.Text := 'dd/mm/yyyy';
    SetEvent(BankingDateEdit, Self, 'OnExit', 'BankingDateEditExit');
    BankingDateEdit.DataField := 'BankingDate';
    BankingDateEdit.DataSource := EditDataSource;
    OtherDonationKindEdit.SetParentComponent(Self);
    OtherDonationKindEdit.Name := 'OtherDonationKindEdit';
    OtherDonationKindEdit.Left := 40;
    OtherDonationKindEdit.Top := 160;
    OtherDonationKindEdit.Width := 504;
    OtherDonationKindEdit.Height := 22;
    OtherDonationKindEdit.AutoSelect := False;
    OtherDonationKindEdit.ChildOrder := 17;
    OtherDonationKindEdit.ElementClassName := 'form-control';
    OtherDonationKindEdit.HeightPercent := 100.000000000000000000;
    OtherDonationKindEdit.WidthPercent := 100.000000000000000000;
    SetEvent(OtherDonationKindEdit, Self, 'OnExit', 'OtherDonationKindEditExit');
    OtherDonationKindEdit.DataField := 'OtherDonationKind';
    OtherDonationKindEdit.DataSource := EditDataSource;
    PaymentMethodNoteEdit.SetParentComponent(Self);
    PaymentMethodNoteEdit.Name := 'PaymentMethodNoteEdit';
    PaymentMethodNoteEdit.Left := 40;
    PaymentMethodNoteEdit.Top := 225;
    PaymentMethodNoteEdit.Width := 504;
    PaymentMethodNoteEdit.Height := 22;
    PaymentMethodNoteEdit.AutoSelect := False;
    PaymentMethodNoteEdit.ChildOrder := 17;
    PaymentMethodNoteEdit.ElementClassName := 'form-control';
    PaymentMethodNoteEdit.HeightPercent := 100.000000000000000000;
    PaymentMethodNoteEdit.WidthPercent := 100.000000000000000000;
    SetEvent(PaymentMethodNoteEdit, Self, 'OnExit', 'PaymentMethodNoteEditExit');
    PaymentMethodNoteEdit.DataField := 'PaymentMethodNote';
    PaymentMethodNoteEdit.DataSource := EditDataSource;
    BankingReferenceCombo.SetParentComponent(Self);
    BankingReferenceCombo.Name := 'BankingReferenceCombo';
    BankingReferenceCombo.Left := 216;
    BankingReferenceCombo.Top := 336;
    BankingReferenceCombo.Width := 328;
    BankingReferenceCombo.Height := 33;
    BankingReferenceCombo.ElementClassName := 'form-select';
    BankingReferenceCombo.HeightPercent := 100.000000000000000000;
    BankingReferenceCombo.Text := 'BankingReferenceCombo';
    BankingReferenceCombo.WidthPercent := 100.000000000000000000;
    BankingReferenceCombo.ItemIndex := -1;
    BankingReferenceCombo.DataField := 'BankingReference';
    BankingReferenceCombo.DataSource := EditDataSource;
    DonationKindCombo.SetParentComponent(Self);
    DonationKindCombo.Name := 'DonationKindCombo';
    DonationKindCombo.Left := 40;
    DonationKindCombo.Top := 120;
    DonationKindCombo.Width := 145;
    DonationKindCombo.Height := 22;
    DonationKindCombo.HeightPercent := 100.000000000000000000;
    DonationKindCombo.WidthPercent := 100.000000000000000000;
    SetEvent(DonationKindCombo, Self, 'OnChange', 'DonationKindComboChange');
    DonationKindCombo.DataField := 'DonationKind';
    DonationKindCombo.DataSource := EditDataSource;
    PaymentMethodCombo.SetParentComponent(Self);
    PaymentMethodCombo.Name := 'PaymentMethodCombo';
    PaymentMethodCombo.Left := 40;
    PaymentMethodCombo.Top := 197;
    PaymentMethodCombo.Width := 145;
    PaymentMethodCombo.Height := 22;
    PaymentMethodCombo.HeightPercent := 100.000000000000000000;
    PaymentMethodCombo.WidthPercent := 100.000000000000000000;
    SetEvent(PaymentMethodCombo, Self, 'OnChange', 'PaymentMethodComboChange');
    PaymentMethodCombo.DataField := 'PaymentMethod';
    PaymentMethodCombo.DataSource := EditDataSource;
    CommentMemo.SetParentComponent(Self);
    CommentMemo.Name := 'CommentMemo';
    CommentMemo.Left := 40;
    CommentMemo.Top := 406;
    CommentMemo.Width := 419;
    CommentMemo.Height := 196;
    CommentMemo.ElementClassName := 'form-control';
    CommentMemo.HeightPercent := 100.000000000000000000;
    CommentMemo.Lines.BeginUpdate;
    try
      CommentMemo.Lines.Clear;
      CommentMemo.Lines.Add('CommentMemo');
    finally
      CommentMemo.Lines.EndUpdate;
    end;
    CommentMemo.SelLength := 0;
    CommentMemo.SelStart := 0;
    CommentMemo.WidthPercent := 100.000000000000000000;
    CommentMemo.DataField := 'Comment';
    CommentMemo.DataSource := EditDataSource;
    AnalysisCode1Combo.SetParentComponent(Self);
    AnalysisCode1Combo.Name := 'AnalysisCode1Combo';
    AnalysisCode1Combo.Left := 40;
    AnalysisCode1Combo.Top := 253;
    AnalysisCode1Combo.Width := 300;
    AnalysisCode1Combo.Height := 33;
    AnalysisCode1Combo.HeightPercent := 100.000000000000000000;
    AnalysisCode1Combo.Text := 'AnalysisCode1Combo';
    AnalysisCode1Combo.WidthPercent := 100.000000000000000000;
    AnalysisCode1Combo.ItemIndex := -1;
    AnalysisCode1Combo.DataField := 'AnalysisCode1';
    AnalysisCode1Combo.DataSource := EditDataSource;
    AnalysisCode2Combo.SetParentComponent(Self);
    AnalysisCode2Combo.Name := 'AnalysisCode2Combo';
    AnalysisCode2Combo.Left := 40;
    AnalysisCode2Combo.Top := 293;
    AnalysisCode2Combo.Width := 300;
    AnalysisCode2Combo.Height := 33;
    AnalysisCode2Combo.HeightPercent := 100.000000000000000000;
    AnalysisCode2Combo.Text := 'AnalysisCode2Combo';
    AnalysisCode2Combo.WidthPercent := 100.000000000000000000;
    AnalysisCode2Combo.ItemIndex := -1;
    AnalysisCode2Combo.DataField := 'AnalysisCode2';
    AnalysisCode2Combo.DataSource := EditDataSource;
    BankingReference2Edit.SetParentComponent(Self);
    BankingReference2Edit.Name := 'BankingReference2Edit';
    BankingReference2Edit.Left := 216;
    BankingReference2Edit.Top := 364;
    BankingReference2Edit.Width := 328;
    BankingReference2Edit.Height := 22;
    BankingReference2Edit.AutoSelect := False;
    BankingReference2Edit.ChildOrder := 17;
    BankingReference2Edit.ElementClassName := 'form-control';
    BankingReference2Edit.HeightPercent := 100.000000000000000000;
    BankingReference2Edit.WidthPercent := 100.000000000000000000;
    BankingReference2Edit.DataField := 'BankingReference2';
    BankingReference2Edit.DataSource := EditDataSource;
    DonationClaimStatus.SetParentComponent(Self);
    DonationClaimStatus.Name := 'DonationClaimStatus';
    DonationClaimStatus.Left := 191;
    DonationClaimStatus.Top := 197;
    DonationClaimStatus.Width := 145;
    DonationClaimStatus.Height := 22;
    DonationClaimStatus.ElementPosition := epIgnore;
    DonationClaimStatus.HeightStyle := ssAuto;
    DonationClaimStatus.HeightPercent := 100.000000000000000000;
    DonationClaimStatus.WidthStyle := ssAuto;
    DonationClaimStatus.WidthPercent := 100.000000000000000000;
    SetEvent(DonationClaimStatus, Self, 'OnChange', 'DonationClaimStatusChange');
    DonationClaimStatus.DataField := 'ClaimStatus';
    DonationClaimStatus.DataSource := EditDataSource;
    EditDataSource.SetParentComponent(Self);
    EditDataSource.Name := 'EditDataSource';
    SetEvent(EditDataSource, Self, 'OnDataChange', 'EditDataSourceDataChange');
    EditDataSource.Left := 216;
    EditDataSource.Top := 24;
    DonationRefresh.SetParentComponent(Self);
    DonationRefresh.Name := 'DonationRefresh';
    DonationRefresh.Enabled := False;
    DonationRefresh.Interval := 100;
    SetEvent(DonationRefresh, Self, 'OnTimer', 'DonationRefreshTimer');
    DonationRefresh.Left := 512;
    DonationRefresh.Top := 552;
  finally
    ErrorMessageDonationDate.AfterLoadDFMValues;
    ErrorMessageAmount.AfterLoadDFMValues;
    ErrorMessageDonationKind.AfterLoadDFMValues;
    ErrorMessagePaymentMethod.AfterLoadDFMValues;
    ErrorMessageDonationClaimStatus.AfterLoadDFMValues;
    DataState.AfterLoadDFMValues;
    AmountDonation.AfterLoadDFMValues;
    DonorPostCode.AfterLoadDFMValues;
    SaveButton.AfterLoadDFMValues;
    CancelButton.AfterLoadDFMValues;
    ClaimStatus.AfterLoadDFMValues;
    DonationDateEdit.AfterLoadDFMValues;
    SponsoredEditDB.AfterLoadDFMValues;
    BankingDateEdit.AfterLoadDFMValues;
    OtherDonationKindEdit.AfterLoadDFMValues;
    PaymentMethodNoteEdit.AfterLoadDFMValues;
    BankingReferenceCombo.AfterLoadDFMValues;
    DonationKindCombo.AfterLoadDFMValues;
    PaymentMethodCombo.AfterLoadDFMValues;
    CommentMemo.AfterLoadDFMValues;
    AnalysisCode1Combo.AfterLoadDFMValues;
    AnalysisCode2Combo.AfterLoadDFMValues;
    BankingReference2Edit.AfterLoadDFMValues;
    DonationClaimStatus.AfterLoadDFMValues;
    EditDataSource.AfterLoadDFMValues;
    DonationRefresh.AfterLoadDFMValues;
  end;
end;

end.
